module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Ajouter les défis de fin de jeu EVJF","labelHasEndGame":"Le jeu a-t-il des défis de fin de jeu ?","textField":"Texte du défi","minScoreField":"Score minimum","maxScoreField":"Score maximum","labelFieldPoi":"Point d\u0027intérêt de fin de jeu"}}')
  delete Component.options._Ctor
}
